/** Shared status chip for the Waste Management Dashboard - status is always conveyed with a
 * text label alongside colour (never colour alone), per accessibility requirements. */

import { Chip } from '@mui/material';
import { PerformanceBand, WasteStatus } from '../types';

const STATUS_COLOR: Record<WasteStatus, 'success' | 'warning' | 'error'> = {
  good: 'success',
  warning: 'warning',
  critical: 'error',
};

const PERFORMANCE_BAND_STATUS: Record<PerformanceBand, WasteStatus> = {
  'Top quartile': 'good',
  'On target': 'good',
  'Needs attention': 'warning',
  Critical: 'critical',
};

interface StatusChipProps {
  status: WasteStatus;
  label: string;
}

export const StatusChip = ({ status, label }: StatusChipProps) => (
  <Chip label={label}
    color={STATUS_COLOR[status]}
    size="small"
    variant="outlined" />
);

interface PerformanceBandChipProps {
  band: PerformanceBand;
}

export const PerformanceBandChip = ({ band }: PerformanceBandChipProps) => (
  <Chip label={band}
    color={STATUS_COLOR[PERFORMANCE_BAND_STATUS[band]]}
    size="small"
    variant="outlined" />
);

export const statusToColor = (status: WasteStatus) => STATUS_COLOR[status];
export const performanceBandToStatus = (band: PerformanceBand) => PERFORMANCE_BAND_STATUS[band];
